import React from "react";
import { Layout } from "../../layouts/Layout";
import { ServicesDetailsFaq } from "../../components/ServicesDetails/ServicesDetailsFaq";
import { CHECK_ICON, SD_VIDEO_IMG, SERVICES_DETAILS01 } from "../../lib/assets";
import { ServicesDetailsWrapper } from "../../components/ServicesDetails/ServicesDetailsWrapper";
import { VideoPlayerOne } from "../../components/VideoPlayers/VideoPlayerOne";
import { BrandSeven } from "../../components/Brand/BrandSeven";

const ServicesDetailsPage = () => {
  return (
    <Layout footer = {2} breadcrumb={"Services"} title={"Management system consultancy"}>
      {/* services-details-area */}
      <ServicesDetailsWrapper hideContact hideTitle>
        <div className="services-details-wrap">
          {/*<div className="services-details-thumb">
            <img src={SERVICES_DETAILS01} alt="" style={{width:"854px", height:"480px"}} />
          </div>
*/}
          <div className="services-details-content">
            <h2 className="title">
            Empower Your Business with Expert Management System Consultancy
            </h2>
            <p>
            In today’s fast-paced and competitive business environment, organizations need robust 
            systems to ensure efficiency, compliance, and continual improvement. 
            At Trio Management Consultants, we offer Management System Consultancy services 
            to help businesses optimize their operations, meet global standards, and drive long-term 
            success. Whether you’re looking to enhance quality, improve sustainability, or streamline 
            processes, our tailored solutions empower your business to thrive.
            </p>
            <p>
            An effective management system forms the backbone of a successful organization.
             It ensures that processes are consistent, risks are managed proactively, and quality and 
             efficiency are always prioritized. Achieving compliance with international standards like 
             ISO 9001 (Quality), ISO 14001 (Environment), and ISO 45001 (Health & Safety) not only 
             positions your business as a trusted leader but also sets you apart from the competition.
            </p>

            <div className="sd-inner-wrap">
              <div className="row align-items-center">
                <div className="col-56">
                  <div className="content">
                    <h3 className="title-two">
                    Our Expertise
                    </h3>
                    <p>
                    At Trio Management Consultants, our experienced consultants work closely with your team to design,
                     implement, and monitor systems that fit your unique business needs. We specialize in:
                    </p>
                    <ul className="list-wrap">
                      <li>
                        <img src={CHECK_ICON} alt="" />
                        Quality Management Systems (QMS)
                      </li>
                      <li>
                        <img src={CHECK_ICON} alt="" />
                        Environmental Management Systems (EMS)
                      </li>
                      <li>
                        <img src={CHECK_ICON} alt="" />
                        Occupational Health & Safety Systems
                      </li>
                      <li>
                        <img src={CHECK_ICON} alt="" />
                        Process Optimization
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="col-44">
                  <div className="thumb">
                    <img src={SD_VIDEO_IMG} alt=""/>
{/*
                    <VideoPlayerOne
                      src={"https://www.youtube.com/watch?v=6mkoGSqTqFI"}
                    /> */}
                  </div>
                </div>
              </div>
            </div>

            <p>
            Transform the way your business operates with our Management System Consultancy services.
             At Trio Management Consultants, we don’t just help you meet compliance requirements—we 
             empower you to exceed them. By improving processes, reducing risks, and enhancing overall 
             performance, we ensure your business stays resilient, competitive, and ready for the future.
            </p>
            <div className="company-benefit-wrap">
              <h2 className="title-two">How We Deliver Value</h2>
              <p>
              At the heart of our approach is a relentless focus on delivering measurable value to our clients.
               We combine expertise, innovation, and customer-centric strategies to ensure impactful 
               outcomes that drive business success. Here’s how we deliver value:
              </p>

              {/* faq accordion */}
              <ServicesDetailsFaq />
            </div>
          </div>
        </div>
      </ServicesDetailsWrapper>

      {/* brand-area */}
      <BrandSeven />
    </Layout>
  );
};

export default ServicesDetailsPage;
